import { useDeviceType } from '@cian/ui-kit';
import { useCallback, useRef, useState } from 'react';
import { useSelector } from 'react-redux';
import { clickSendForm } from 'shared/components/tracking';
import { MAX_VALUE_PHONE } from 'shared/constants/form';
import { useAppDispatch } from 'shared/hooks';
import { selectUser } from 'shared/selectors/user';
import { setStatus } from 'shared/slices';
import { sendModalForm } from 'shared/thunks';
import { EStatus, IForm } from 'shared/types/form';

interface IFormContainerProps {
  Form: React.FC<IForm>;
  onChangeModalVisible?: VoidFunction;
}

export const FormContainer: React.FC<IFormContainerProps> = ({ Form, onChangeModalVisible }) => {
  const user = useSelector(selectUser);

  const userId = user?.isAuthenticated && user.userId ? user.userId : undefined;

  const phoneRef = useRef<HTMLInputElement>(null);
  const checkBoxRef = useRef<HTMLInputElement>(null);

  const dispatch = useAppDispatch();

  const device = useDeviceType();

  const [disabled, setDisabled] = useState(true);

  const sendCallbackForm = useCallback(async () => {
    const phone = String(phoneRef?.current?.value.replace(/[+-\s]/g, ''));

    const checkBox = Boolean(checkBoxRef.current?.checked);

    const res = await dispatch(
      sendModalForm({
        phone,
        userId: user?.isAuthenticated ? user.userId : null,
      }),
    ).unwrap();

    clickSendForm(phone, checkBox, res.status === 'success', userId);
  }, [dispatch, user, userId]);

  const checkFilledInput = useCallback(() => {
    setDisabled(Boolean(phoneRef.current?.value.length !== MAX_VALUE_PHONE || !checkBoxRef.current?.checked));
  }, []);

  const backToForm = useCallback(async () => {
    dispatch(setStatus(EStatus.Initial));
    setDisabled(true);
  }, [dispatch]);

  return (
    <Form
      phoneRef={phoneRef}
      checkBoxRef={checkBoxRef}
      backToForm={backToForm}
      onClose={onChangeModalVisible}
      onSendForm={sendCallbackForm}
      onFilledInput={checkFilledInput}
      device={device}
      disabledButton={disabled}
      user={{ phone: user?.isAuthenticated ? user.phone : '' }}
    />
  );
};
